import React from "react";
import "./iFrame11.scss";
import IframeHeader from "../iFrameHeader/IframeHeader";
import IframeImg from "../iFrameImg/IframeImg";
import IFrameText from "../iFrameText/IFrameText";

const IFrame11 = ({ refValue, iFrameData, fileData }) => {
    return (
        <>
            {iFrameData && (
                <div className="iframe-11-content" ref={refValue}>
                    <IframeHeader
                        title={iFrameData.title}
                        department={fileData.department.title}
                        equipment={fileData.equipment.title}
                        design={fileData.design.title}
                        iFrameNum={11}
                    />
                    <div className="iframe-11-content__body">
                        <div className="iframe-11-content__body-item item-a">
                            <IFrameText
                                classNameParam={"text-h-a"}
                                text={<div dangerouslySetInnerHTML={{ __html: iFrameData.fields.field_1.content }} />}
                            />
                        </div>
                        <div className="iframe-11-content__body-item item-b">
                            <IFrameText
                                classNameParam={"text-h-b"}
                                text={<div dangerouslySetInnerHTML={{ __html: iFrameData.fields.field_2.content }} />}
                            />
                        </div>
                        <div className="iframe-11-content__body-item img-a">
                            <IframeImg
                                imgSrc={iFrameData.fields.field_3.content.url}
                                isTrue={iFrameData.fields.field_3.content.status}
                                classNameParam={"img-h-c"}
                            />
                            <div className="iframe-4-content__body-item-subtitle">
                                {iFrameData.fields.field_3.content.subtitle}
                            </div>
                        </div>
                        <div className="iframe-11-content__body-item img-b">
                            <IframeImg
                                imgSrc={iFrameData.fields.field_4.content.url}
                                isTrue={iFrameData.fields.field_4.content.status}
                                classNameParam={"img-h-a"}
                            />
                            <div className="iframe-4-content__body-item-subtitle">
                                {iFrameData.fields.field_4.content.subtitle}
                            </div>
                        </div>
                        <div className="iframe-11-content__body-item img-c">
                            <IframeImg
                                imgSrc={iFrameData.fields.field_5.content.url}
                                isTrue={iFrameData.fields.field_5.content.status}
                                classNameParam={"img-h-b"}
                            />
                            <div className="iframe-4-content__body-item-subtitle">
                                {iFrameData.fields.field_5.content.subtitle}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default IFrame11;
